import { SET_CURRENCY } from "./action-types";

// action creator : function which returns an action
export const setCurrency = (currency) => ({
  type: SET_CURRENCY,
  payload: { currency },
});
